import { render, staticRenderFns } from "./home.vue?vue&type=template&id=2d0baf9b&scoped=true&lang=pug&"
import script from "./home.vue?vue&type=script&lang=js&"
export * from "./home.vue?vue&type=script&lang=js&"
import style0 from "./home.vue?vue&type=style&index=0&id=2d0baf9b&prod&lang=sass&scoped=true&"
import style1 from "./home.vue?vue&type=style&index=1&id=2d0baf9b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0baf9b",
  null
  
)

export default component.exports